<template>
  <div ref="wrapper" class="rui-thumbnails">
    <!--
      Tells parent to display the picture
      @event open
    -->
    <a v-for="urls in list"
       :key="urls.source"
       :href="urls.source"
       class="_thumbnail"
       @click.prevent="$emit('open', urls.source)">
      <img ref="image" :data-src="urls.thumbnail" :alt="$t('rui.image_viewer.a_thumbnail')">
    </a>
  </div>
</template>

<script>
/**
 * Displays thumbnails from a list of URLs.
 *
 * @preset Default { "props" : {
 *                    "list": [
 *                      { "source": "https://picsum.photos/id/10/1080/1920", "thumbnail": "https://picsum.photos/id/10/180/320"},
 *                      { "source": "https://picsum.photos/id/11/1080/1920", "thumbnail": "https://picsum.photos/id/11/180/320"},
 *                      { "source": "https://picsum.photos/id/12/1080/1920", "thumbnail": "https://picsum.photos/id/12/180/320"},
 *                      { "source": "https://picsum.photos/id/13/1080/1920", "thumbnail": "https://picsum.photos/id/13/180/320"},
 *                      { "source": "https://picsum.photos/id/14/1080/1920", "thumbnail": "https://picsum.photos/id/14/180/320"},
 *                      { "source": "https://picsum.photos/id/15/1080/1920", "thumbnail": "https://picsum.photos/id/15/180/320"}
 *                    ]
 *                 } }
 */
export default {
  name: 'RuiThumbnails',
  emits: [
    'open',
  ],
  props: {
    /**
     * List of pictures
     *
     * Should be an array of objects like
     * ```js
     * [
     * {source: 'url-to-full-image', thumbnail: 'url-to-thumbnail'}
     * ]
     * ```
     */
    list: { required: true, type: Array },
  },
  methods: {
    lazyLoad () {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          this.$refs.image.forEach((el) => { el.src = el.dataset.src })
          observer.unobserve(this.$refs.wrapper)
        })
      }, { root: null, rootMargin: '0px 0px 300px 0px' })

      this.$nextTick(() => {
        observer.observe(this.$refs.wrapper)
      })
    },
  },
  created () {
    // There's a bug with Firefox and the "loading=lazy" attribute resulting into all images being loaded at once.
    // Let's lazy-load them manually then.
    this.lazyLoad()
  },
}
</script>
